import React from "react"
import { EditBandFormField } from "./EditBandFormField"
import { Band } from "../../types/bands"

interface BandBioProps {
  band: Band
}

export const BandBio: React.FC<BandBioProps> = ({ band }) => {
  const fieldData = {
    field: "bio",
    name: "bandBio",
    label: "Bio",
    placeholder: "What are y'all about? (hint: update this regularly)",
    required: false,
    maxLength: 260,
  }

  return <EditBandFormField type="text" fieldData={fieldData} />
}
